import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import LiveProjects from "../../containers/liveprojects/LiveProjects";
import CompetitiveSites from "../../components/liveProjectsSites/LiveProjectsSites";
import EducationImg from "./LiveProjectImg";
import { liveprojectsite } from "../../portfolio";
import "./LiveProjects.css";
import { Fade } from "react-reveal";

class LiveProject extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="education-main">
        <Header theme={this.props.theme} />
        <div className="basic-education">
          <Fade bottom duration={2000} distance="40px">
            <div className="heading-div">
              <div className="heading-img-div">
                {/* <img
									src={require("../../assests/images/education.svg")}
									alt=""
								/> */}
                <EducationImg theme={theme} />
              </div>
              <div className="heading-text-div">
                <h1 className="heading-text" style={{ color: theme.text }}>
                  Available
                </h1>
                <h3 className="heading-sub-text" style={{ color: theme.text }}>
                  Live Projects
                </h3>
                <CompetitiveSites logos={liveprojectsite.liveprojectsite} />
                <h5 className="heading-sub-text" style={{ color: theme.text }}>
                  Description Below
                </h5>
              </div>
            </div>
          </Fade>
          <LiveProjects theme={this.props.theme} />
        </div>
        <Footer theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default LiveProject;
